import {RadioGroup} from '../RadioGroup';
import {StarRatingGroup} from './StarRatingGroup';

export class ScaleQuestion {
  constructor(questionNode, onChange, type) {
    this.domNode = questionNode;
    this.onChange = onChange;
    this.groups = [];
    this.type = type;

    switch (type) {
      case 'NP':
      case 'CL':
        this.initRadioGroups();
        break;
      case 'ST':
        this.initStarGroups();
    }
  }

  initRadioGroups() {
    var groups = Array.from(this.domNode.querySelectorAll('[role="radiogroup"]'));
    this.groups = groups.map((group) => {
      var radioDomNodes = Array.from(group.querySelectorAll('[role="radio"]'));
      return new RadioGroup(radioDomNodes, this.onChange);
    });
  }

  initStarGroups() {
    var groups = Array.from(this.domNode.querySelectorAll('[role="radiogroup"]'));
    this.groups = groups.map((group) => {
      return new StarRatingGroup(group, this.onChange);
    });
  }
}
